import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import {  useNavigate, useParams } from 'react-router-dom';
import { getOneUser, updateUser } from '../Redux/Actions/AuthActions';

const UpdateUser = () => {

    const{id}=useParams()

    const dispatch =useDispatch()

    useEffect(()=>{

      dispatch(getOneUser(id))

    },[])

    const upUser = useSelector(state => state.AuthReducer.upUser);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [matricule, setMatricule] = useState('');
    const [localisation, setLocalisation] = useState('');
    const [salaire, setSalaire] = useState('');
    const [phone, setPhone] = useState('');
    const [commissionRate, setCommissionRate] = useState(10);
       
    useEffect(() => {
      if (upUser) {
        setName(upUser.name || '');
        setEmail(upUser.email || '');
        setMatricule(upUser.matricule || '');
        setLocalisation(upUser.localisation || '');
        setSalaire(upUser.salaire || '');
        setPhone(upUser.phone || '');
        setCommissionRate(upUser.commissionRate !== undefined ? upUser.commissionRate : 10);
      }
    }, [upUser]);

    const navigate = useNavigate()
    const handleUpdate=(a)=>{
      a.preventDefault()
      dispatch(updateUser(id,{name,email,matricule,localisation, salaire,phone, commissionRate},navigate))
    }

  return (
    <Form className="p-4" style={{ maxWidth: '600px', margin: '100px auto' }}>
      <h3 className="mb-4 text-primary font-weight-bold">Modifier l'utilisateur</h3>

      <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control value={name}  onChange ={(e) => setName(e.target.value)} type="name" placeholder="Enter Name" />
      </Form.Group>
    
      <Form.Group className="mb-3">
          <Form.Label>Email Adress</Form.Label>
          <Form.Control value={email}  onChange ={(e) => setEmail(e.target.value)} type="email" placeholder="Enter email" />
      </Form.Group>
    
      <Form.Group className="mb-3">
        <Form.Label>Matricule</Form.Label>
          <Form.Control value={matricule}  onChange ={(e) => setMatricule(e.target.value)} type="matricule" placeholder="Enter votre matricule" />
      </Form.Group>
    
      <Form.Group className="mb-3">
          <Form.Label>Localisation</Form.Label>
          <Form.Control value={localisation}  onChange ={(e) => setLocalisation(e.target.value)} type="localisation" placeholder="localisation" />
      </Form.Group>

      <Form.Group className="mb-3">
          <Form.Label>Salaire</Form.Label>
          <Form.Control value={salaire}  onChange ={(e) => setSalaire(e.target.value)} type="number" placeholder="salaire" />
      </Form.Group>

      <Form.Group className="mb-3">
          <Form.Label>Numero de téléphone</Form.Label>
          <Form.Control value={phone}  onChange ={(e) => setPhone(e.target.value)} type="phone" placeholder="Numero de téléphone" />
      </Form.Group>

      {upUser && upUser.role === 'provider' && (
        <Form.Group className="mb-4">
            <Form.Label className="font-weight-bold text-success">Taux de Commission (%)</Form.Label>
            <Form.Control 
              value={commissionRate}  
              onChange={(e) => setCommissionRate(parseFloat(e.target.value) || 0)} 
              type="number" 
              min="0"
              max="100"
              placeholder="Ex: 10" 
              style={{ borderColor: 'var(--brand-gold)' }}
            />
            <Form.Text className="text-muted">
              Ce pourcentage de commission sera prélevé sur toutes les réservations en ligne de ce prestataire.
            </Form.Text>
        </Form.Group>
      )}
      
      <Button onClick={(e)=>handleUpdate(e)} variant="primary" type="submit">
        Enregistrer les modifications
      </Button>
    </Form>
  );
};

export default UpdateUser;
